import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceStructureUnitListSearchSchema } from '../-shared/attendance-structure-unit-list-search-schema';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/attendance-units/')({
  validateSearch: zodValidator(AttendanceStructureUnitListSearchSchema)
});